var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dan"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"sub-dan",class:{checked:_vm.checked(_vm.data)},on:{"click":function($event){return _vm.handleClick(_vm.data.name,_vm.data.name,_vm.data.level)}}},[_vm._v("\n    "+_vm._s(_vm.data.name)+"\n  ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }